import {

    CREATE_PRODUCT_REQUEST,
    CREATE_PRODUCT_SUCCESS,
    CREATE_PRODUCT_FAIL,
    CREATE_PRODUCT_RESET,


    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAIL,
    UPDATE_PRODUCT_RESET,


    ALL_PRODUCTS_REQUEST,
    ALL_PRODUCTS_SUCCESS,
    ALL_PRODUCTS_FAIL,



    SINGLE_PRODUCT_REQUEST,
    SINGLE_PRODUCT_SUCCESS,
    SINGLE_PRODUCT_FAIL,

    MULTI_PRODUCT_UPDATE_REQUEST,
    MULTI_PRODUCT_UPDATE_SUCCESS,
    MULTI_PRODUCT_UPDATE_RESET,
    MULTI_PRODUCT_UPDATE_FAIL,

    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAIL,
    DELETE_PRODUCT_RESET,

    CLEAR_ERRORS
} from "../constants//productConstants";

export const createProductReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_PRODUCT_REQUEST:
        case UPDATE_PRODUCT_REQUEST:

            return {
                ...state,
                loading: true
            };

        case CREATE_PRODUCT_SUCCESS:
        case UPDATE_PRODUCT_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload
            };

        case CREATE_PRODUCT_FAIL:
        case UPDATE_PRODUCT_FAIL:
            return {
                loading: false,
                error: action.payload,
            };

        case CREATE_PRODUCT_RESET:
        case UPDATE_PRODUCT_RESET:
            return {
                ...state,
                loading: false,
                message: null
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};
export const allProductReducer = (state = {}, action) => {
    switch (action.type) {
        case ALL_PRODUCTS_REQUEST:
        case SINGLE_PRODUCT_REQUEST:
            return {
                ...state,
                loading: true
            };

        case ALL_PRODUCTS_SUCCESS:
            return {
                loading: false,
                success: true,
                products: action.payload.products,
                totalProducts: action.payload.totalProducts,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                perPage: action.payload.perPage,
                totalorders: action.payload.totalorders,
                overallComission: action.payload.overallComission
            };
        case SINGLE_PRODUCT_SUCCESS:
            return {
                loading: false,
                success: true,
                product: action.payload.product,
            };

        case ALL_PRODUCTS_FAIL:
        case SINGLE_PRODUCT_FAIL:
            return {
                loading: false,
                error: action.payload,
            };


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};


export const multiProductUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case MULTI_PRODUCT_UPDATE_REQUEST:

            return {
                ...state,
                loading: true
            };

        case MULTI_PRODUCT_UPDATE_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload
            };

        case MULTI_PRODUCT_UPDATE_RESET:
            return {
                ...state,
                loading: false,
                message: null,
                success: false
            };

        case MULTI_PRODUCT_UPDATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};


export const deleteProductReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_PRODUCT_REQUEST:
            return {
                ...state,
                loading: true
            };

        case DELETE_PRODUCT_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload
            };

        case DELETE_PRODUCT_FAIL:
            return {
                loading: false,
                error: action.payload,
            };

        case DELETE_PRODUCT_RESET:
            return {
                ...state,
                loading: false,
                message: null,
                success: false
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};